import type { RouteDef } from "../route-config";
import { AddRealmRoute } from "./routes/AddRealm";

const routes: RouteDef[] = [AddRealmRoute];

export default routes;
